
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Wrapper } from './styled';
import Table from 'Screens/Credentials/components/Table';
import getColumns from '../columns';
import { selectIsFetching } from 'store/Credentials/selectors';

const DetailTable = () => {
  const [hidePass, setHidePass] = useState(true);
  const isFetching = useSelector(selectIsFetching);
  const columns = getColumns(hidePass, setHidePass, isFetching);

  return (
    <Wrapper>
      <Table columns={ columns } hidePass={ hidePass } setHidePass={ setHidePass } isVulnDetail />
    </Wrapper>
  );
};

export default DetailTable;
